module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/data-bg-2-lion.27a6c121.png";